/**
 * Copyright 2014-present Palantir Technologies
 * @license MIT
 */
"use strict";
/*
 * WARNING: The js output of this expression is searched by string (yes, I know) and replaced with a
 * real version number during the dist phase for for npm module publishing. Modifying this line should
 * be accompanied by modifying the "sed-version" task in package.json accordingly.
 */
exports.version = "3.5.4";



//////////////////
// WEBPACK FOOTER
// ./~/plottable/build/src/core/version.js
// module id = 977
// module chunks = 0